import {TrackingServiceCard} from "./tracking_service_card";
import {CinemaChangeEvent, CinemaInitializedEvent, TrackingActionType, TrackingFeatureLabels} from "../types";
import Tile from "./tile";

export default class ShopPromoSmallCard {
    private readonly featureOrder: number;
    private readonly masFeatureTrackingLabels: TrackingFeatureLabels
    private readonly personalizationContext: string;
    private readonly featureIndex: number;
    readonly tiles: Tile[];
    private trackingService: TrackingServiceCard;

    constructor(shopPromoSmallCardDom: Element) {
        this.featureIndex = this.getFeatureIndex(shopPromoSmallCardDom);
        this.masFeatureTrackingLabels = this.getMasFeatureTrackingLabels(shopPromoSmallCardDom);
        this.featureOrder = this.getFeatureOrder(shopPromoSmallCardDom);
        this.personalizationContext = this.getPersonalizationContext(shopPromoSmallCardDom);
        this.trackingService = new TrackingServiceCard();
        this.tiles = Array.from(shopPromoSmallCardDom.querySelectorAll(".pl_promo-card--link")).map((tileDom) => new Tile(tileDom as HTMLElement));

        this.tiles.forEach((tile) => {
            tile.tileDom.addEventListener("click", () => this.trackClickSmallShopPromo(tile))
        })

        /*🤫*/
        const cinemaDom = shopPromoSmallCardDom.querySelector(".promo_shoppromo-small-card--cinema");
        cinemaDom?.setAttribute("data-feature-index", this.featureIndex.toString());

        window.o_global.eventQBus.on("pattern.carousel.mounted", (e) => this.trackInitialViewSmallShopPromo(e));
        window.o_global.eventQBus.on("pattern.carousel.stage.changed", (e) => this.trackSlideSmallShopPromo(e));

        window.o_global.eventQBus.emit(
            "pattern.carousel.init",
            `.promo_shoppromo-small-card--container[data-feature-index="${this.featureIndex}"] .js_pl_carousel`
        )

    }

    trackInitialViewSmallShopPromo(e: CinemaInitializedEvent): void {
        const eventFeatureIndex = this.getFeatureIndex(e.element);
        if (e.element.className.includes("promo_shoppromo-small-card--cinema") && eventFeatureIndex == this.featureIndex && !e.element.parentElement?.getAttribute("data-tracked")) {
            e.element.parentElement?.setAttribute("data-tracked", String(true));
            const visibleTiles = this.getVisibleTiles(this.tiles, e.currentSlides)

            this.trackingService.sendSmallShoppromoInitialViewTrackingEvent(this.featureOrder, this.featureIndex, this.personalizationContext, this.tiles.length, visibleTiles, this.masFeatureTrackingLabels);
        }
    }

    trackSlideSmallShopPromo(e: CinemaChangeEvent): void {
        const eventFeatureIndex = this.getFeatureIndex(e.element);
        if (e.element.className.includes("promo_shoppromo-small-card--cinema") && eventFeatureIndex == this.featureIndex) {
            const visibleTiles = this.getVisibleTiles(this.tiles, e.currentSlides)
            const movementType: TrackingActionType = e.scrollingRight ? "next" : "previous"
            this.trackingService.sendSmallShoppromoSlideTrackingEvent(this.featureOrder, this.featureIndex, this.personalizationContext, this.tiles.length, visibleTiles, movementType, this.masFeatureTrackingLabels);
        }
    }

    trackClickSmallShopPromo(tile: Tile): void {
        this.trackingService.sendSmallShoppromoClickTrackingEvent(this.featureOrder, this.featureIndex, this.personalizationContext, this.tiles.length, tile, this.masFeatureTrackingLabels);
    }

    private getVisibleTiles(tiles: Array<Tile>, currentSlides: number[]) {
        const tilesPerSlide = 2;
        const start = currentSlides[0] * tilesPerSlide;
        const end = (currentSlides[currentSlides.length - 1] + 1) * tilesPerSlide;
        return tiles.slice(start, end);
    }

    private getFeatureOrder(container: Element): number {
        const dataFeatureOrder = container.closest('[data-feature-order]')?.getAttribute('data-feature-order');
        return dataFeatureOrder ? parseInt(dataFeatureOrder, 0) : -1;
    }

    private getMasFeatureTrackingLabels(container: Element): TrackingFeatureLabels {
        const dataFeatureTrackingLabels = container.closest('[data-feature-order]')?.getAttribute('data-feature-tracking-labels');
        return dataFeatureTrackingLabels ? JSON.parse(dataFeatureTrackingLabels) : {};
    }

    private getFeatureIndex(htmlElement: Element): number {
        return parseInt(htmlElement.getAttribute('data-feature-index')!, 0);
    }

    private getPersonalizationContext(shopPromoSmallCardDom: Element): string {
        return shopPromoSmallCardDom.getAttribute('data-context')!
    }
}